export default "__VITE_ASSET__DesH_STX__"